import React from "react";
import { propOr } from "ramda";
import {
  Div,
  SmallAvatar,
  TinyAvatar,
  BigAvatar,
  SuperAvatar,
  HugeAvatar
} from "components/Base";

const Avatar = ({
  name = "",
  id = null,
  type = "small",
  square = true,
  ...props
}) => (
  <Div display="row.flex-start.center">
    {propOr(null, type, {
      huge: <HugeAvatar text={name} id={id} square={square} {...props} />,
      super: <SuperAvatar text={name} id={id} square={square} {...props} />,
      big: <BigAvatar text={name} id={id} square={square} {...props} />,
      small: <SmallAvatar text={name} id={id} square={square} {...props} />,
      tiny: <TinyAvatar text={name} id={id} square={square} {...props} />
    })}
  </Div>
);

export default Avatar;
